export default "__VITE_ASSET__5578242d__";